(() => {
  const init = () => {
    const root = document.querySelector('[data-payment-preview]');
    if (!root) return;

    const variantInput = root.querySelector('[data-variant-id]');
    const variants = [...root.querySelectorAll('[data-payment-variant]')];
    const stageTitle = root.querySelector('[data-stage-title]');
    const stageDescription = root.querySelector('[data-stage-description]');
    const amountLabel = root.querySelector('[data-amount-label]');
    const amountValue = root.querySelector('[data-amount-value]');
    const submitButton = root.querySelector('[data-payment-submit]');
    const submitLabel = root.querySelector('[data-pay-label]');
    const previewOnly = root.dataset.previewOnly === 'true';
    const requestedId = new URLSearchParams(window.location.search).get('variant');
    const selected = variants.find((variant) => variant.dataset.id === requestedId)
      || variants.find((variant) => variant.dataset.id === variantInput?.value)
      || variants[0];

    if (selected) {
      const title = selected.dataset.title || 'Project payment';
      const price = selected.dataset.priceText || 'Set in Shopify';
      const configured = selected.dataset.priceReady === 'true';

      if (variantInput) variantInput.value = selected.dataset.id || '';
      if (stageTitle) stageTitle.textContent = title;
      if (stageDescription) stageDescription.textContent = selected.dataset.description || '';
      if (amountLabel) amountLabel.textContent = title;
      if (amountValue) amountValue.textContent = price;

      if (submitButton) {
        const locked = previewOnly || !configured;
        submitButton.disabled = locked;
        if (submitLabel) {
          submitLabel.textContent = previewOnly
            ? submitButton.dataset.labelLocked
            : !configured
              ? submitButton.dataset.labelUnpriced
              : 'Continue to secure payment';
        }
      }
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
